// extracted by mini-css-extract-plugin
module.exports = {"authFormInput":"LoginFormInput_authFormInput__24KQD"};